export default {
  countryCode: 'AE',
  regionLinks: [
    {
      title: 'Dubai',
    },
    {
      title: 'Abu Dhabi',
    },
  ],
};
